export {};

const initRedirectToAgentsPortal = (el: Element) => {
  const redirectUrl = el.getAttribute("data-redirect-to-agents-portal");
  if (!redirectUrl) {
    return;
  }

  if (window.confirm("Please book viewings using the agents portal. Redirect to the agents portal?")) {
    window.location.href = redirectUrl;
  }
};

const el = document.currentScript;
if (el) {
  initRedirectToAgentsPortal(el);
}
